// These values are replaced by the webpack define plugin
export var __REDWOOD__ = {
  API_PROXY_PATH: __REDWOOD__API_PROXY_PATH
};